<template>
    <v-app-bar
        app
        fixed
        elevation="1"
        class="norfield-app-bar"
        dense
    >
        <v-btn
            plain
            class="nav-drawer-button"
            @click="onClickNavMenu"
        >
            <v-icon color="#7F8592">
                {{ hamburgerIcon }}
            </v-icon>
        </v-btn>

        <span
            v-if="this.$vuetify.breakpoint.xsOnly"
            class="pt-1 ml-1"
        >
            <LocatorLogixLogo />
        </span>

        <v-toolbar-title
            class="d-none d-sm-inline"
        >
            <strong>{{ companyName }}</strong>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
            v-if="alertsAudioOn"
            class="mr-5" 
            outlined
            small
            color="error"
            @click="onDismissAlarm"
        >
            <v-icon class="material-icons-outlined">
                campaign
            </v-icon>
            Dismiss Alarm
        </v-btn>
        <AppBarUserMenu />        
    </v-app-bar>
</template>
<script>
import AppBarUserMenu from './AppBarUserMenu.vue';
import webtmsBackend from '@/services/webtmsBackend';
import LocatorLogixLogo from './CustomIcons/LocatorLogixLogo';

export default {
    name: 'AppBar',
    components: {
        AppBarUserMenu,
        LocatorLogixLogo,
    },
    props: {
        hamburgerIcon: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            heartbeatInterval: null,
        };
    },
    computed: {
        companyName() {
            return this.$store.getters.company.company;
        },
        alertsAudioOn() {
            return this.$store.getters.alertsAudioOn;
        }
    },
    mounted() {
        this.heartbeatInterval = setInterval(() => {
            this.heartbeatCheck();
        }, 15 * 1000);
    },
    destroyed() {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
    },
    methods: {
        onDismissAlarm() {
            this.$store.commit('SET_ALERTS_AUDIO_ON', false);
        },
        onClickNavMenu() {
            if(this.$vuetify.breakpoint.xsOnly) {
                this.$emit('toggle-navdrawer');
            } else {
                this.$emit('toggle-navbar');
            }
        },
        heartbeatCheck() {
            webtmsBackend.heartbeat()
                .then(data => {
                    const serverDate = new Date(data);

                    if (isFinite(serverDate.valueOf())) {
                        // we are online!
                        this.$store.commit('SET_LOST_INTERNET', false);
                        this.$store.commit('SET_OFFLINE_SINCE', null);

                        // to avoid incorrectly overwriting the value on each heartbeat,
                        // we should only update the Vuex "Online Since" value if there isn't one already
                        if (!this.$store.getters.onlineSince) {
                            this.$store.commit('SET_ONLINE_SINCE', new Date());
                        }
                    }
                })
                .catch(() => {
                    this.$store.commit('SET_LOST_INTERNET', true);

                    // when they have lost internet, we do not have to tell them how long they have been offline for
                    this.$store.commit('SET_OFFLINE_SINCE', null);
                    this.$store.commit('SET_ONLINE_SINCE', null);
                });
        },
    },
};
</script>
<style scoped>
.norfield-app-bar .nav-drawer-button {
    left: -5px;
    padding: 0px;
    min-width: 34px;
    width: 34px;
    height: 34px;
    min-height: 34px;
}
</style>
